/*
  Bundles landing page (sections/bundle-lp-picker.liquid).

  - Picker: one bundle size and one scent selected; the cards, summary bar
    and sticky bar follow.
  - "Add [bundle] to cart": the bag goes in as ONE one-time line, quantity =
    bags, property _bundle = "<bags>-pack" - the line the bundle-discount
    function prices and the cart gift reconciler gives gifts for. A bundle
    already in the cart is replaced (one bundle per cart); everything else in
    the cart stays. Then the gifts are reconciled and the visitor goes
    straight to checkout (CartGifts.goWhenSettled, as the old flow pages do).
  - Sticky add-to-cart bar at the top of the screen on phones.
  - Rating and review count read live from Yotpo.
  - Tracking: view_item on load and add_to_cart on click, for GTM (GA4
    ecommerce format) and Klaviyo. Shopify's own product_added_to_cart, which
    the Meta, Google, Klaviyo and Triple Whale apps listen to, is emitted by
    Shopify itself for the /cart/add.js call.
*/
(function () {
  'use strict';

  // The cart gift reconciler ignores requests carrying this header. Our two
  // writes (remove the old bundle, add the new one) must not each start a
  // reconcile of their own in between: concurrent cart writes undo each other.
  // goWhenSettled reconciles once, after both.
  var CART_GIFTS_MARKER = 'X-Cart-Gifts';
  var SETTLE_FALLBACK = 4000;

  var root = document.querySelector('[data-sbl-picker]');
  var dataNode = document.querySelector('[data-sbl-data]');
  var data = null;
  try {
    data = dataNode ? JSON.parse(dataNode.textContent) : null;
  } catch (error) {
    data = null;
  }

  /* ---- helpers --------------------------------------------------------------- */

  function formatMoney(cents) {
    var format = (data && data.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, kind) {
      if (kind === 'amount_no_decimals') return withCommas;
      if (kind === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      if (kind === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return withCommas + '.' + parts[1];
    }).replace(/<[^>]*>/g, '');
  }

  function fill(template, values) {
    return String(template || '').replace(/\[(\w+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function post(url, payload) {
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    headers[CART_GIFTS_MARKER] = '1';
    return fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(payload), credentials: 'same-origin' });
  }

  function getCart() {
    var headers = { Accept: 'application/json' };
    headers[CART_GIFTS_MARKER] = '1';
    return fetch('/cart.js', { headers: headers, credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('cart ' + response.status);
      return response.json();
    });
  }

  /* ---- rating from Yotpo --------------------------------------------------------- */

  (function rating() {
    var node = document.querySelector('[data-sbl-rating]');
    if (!node || !window.fetch) return;

    var key = node.getAttribute('data-app-key');
    var productId = node.getAttribute('data-product-id');
    var template = node.getAttribute('data-template');
    var text = node.querySelector('[data-sbl-rating-text]');
    if (!key || !productId || !template || !text) return;

    fetch('https://api-cdn.yotpo.com/v1/widget/' + encodeURIComponent(key) + '/products/' + encodeURIComponent(productId) + '/reviews.json?per_page=1&page=1')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (body) {
        var bottomline = body && body.response && body.response.bottomline;
        if (!bottomline || !bottomline.total_review) return;
        text.textContent = template
          .replace('{score}', Number(bottomline.average_score).toFixed(1))
          .replace('{count}', Number(bottomline.total_review).toLocaleString('en-US'));
      })
      .catch(function () {
        /* The fallback text stays. */
      });
  })();

  /* ---- FAQ: one answer open at a time ------------------------------------------- */

  // The <details> share a name, which browsers since 2024 treat as an
  // exclusive group on their own. This does the same for older ones.
  document.querySelectorAll('[data-sbl-faq]').forEach(function (list) {
    var items = Array.prototype.slice.call(list.querySelectorAll('details'));
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  });

  if (!root || !data) return;

  /* ---- state ------------------------------------------------------------------- */

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sbl-card]'));
  var scentButtons = Array.prototype.slice.call(root.querySelectorAll('[data-sbl-scent]'));
  var addButtons = Array.prototype.slice.call(document.querySelectorAll('[data-sbl-add]'));
  var summaryText = root.querySelector('[data-sbl-summary-text]');
  var errorNode = root.querySelector('[data-sbl-error]');
  var sticky = document.querySelector('[data-sbl-sticky]');
  var stickyName = document.querySelector('[data-sbl-sticky-name]');
  var stickyPrice = document.querySelector('[data-sbl-sticky-price]');
  var strings = data.strings || {};

  if (cards.length === 0) return;

  var tiers = cards.map(function (card) {
    return {
      card: card,
      bags: parseInt(card.getAttribute('data-bags'), 10),
      name: card.getAttribute('data-name'),
      price: parseInt(card.getAttribute('data-price'), 10),
      gifts: parseInt(card.getAttribute('data-gifts'), 10) || 0
    };
  });

  var state = {
    bags: data.defaultBags,
    variantId: data.defaultVariantId,
    busy: false
  };

  function currentTier() {
    var found = null;
    tiers.forEach(function (tier) {
      if (tier.bags === state.bags) found = tier;
    });
    return found || tiers[tiers.length - 1];
  }

  function currentVariant() {
    var found = null;
    (data.variants || []).forEach(function (variant) {
      if (variant.id === state.variantId) found = variant;
    });
    return found || data.variants[0];
  }

  function giftsText(count) {
    if (count === 1) return ' + ' + strings.giftOne;
    if (count > 1) return ' + ' + fill(strings.giftOther, { count: count });
    return '';
  }

  function render() {
    var tier = currentTier();
    var variant = currentVariant();

    tiers.forEach(function (item) {
      var on = item === tier;
      item.card.classList.toggle('is-selected', on);
      item.card.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    scentButtons.forEach(function (button) {
      var on = parseInt(button.getAttribute('data-sbl-scent'), 10) === variant.id;
      button.classList.toggle('is-selected', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    if (variant.src) swapBagImages(variant);

    var summary = fill(strings.summary, {
      name: tier.name,
      scent: variant.label,
      gifts: giftsText(tier.gifts),
      price: formatMoney(tier.price)
    });
    if (summaryText) summaryText.textContent = summary;
    if (stickyName) stickyName.textContent = tier.name + ' · ' + variant.label;
    if (stickyPrice) stickyPrice.textContent = formatMoney(tier.price);

    addButtons.forEach(function (button) {
      var label = button.querySelector('[data-sbl-add-label]');
      if (label && !state.busy) label.textContent = fill(strings.button, { name: tier.name });
      button.toggleAttribute('disabled', !variant.available && !state.busy);
    });

    if (!variant.available) showError(strings.soldOut);
    else hideError();
  }

  /* ---- scent switch: the bag slides out to the right, the new one in ---------------- */

  var BAG_SLIDE_MS = 220;
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var bagSwap = 0;

  function setBagImage(image, variant) {
    image.setAttribute('srcset', variant.srcset);
    image.setAttribute('src', variant.src);
    image.setAttribute('alt', variant.alt);
  }

  // Resolves once the new bag is downloaded (or after a short wait), so the
  // slide in never shows an empty frame.
  function preload(variant) {
    return new Promise(function (resolve) {
      var probe = new Image();
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        resolve();
      }
      probe.onload = finish;
      probe.onerror = finish;
      probe.sizes = window.innerWidth < 750 ? '128px' : '234px';
      probe.srcset = variant.srcset;
      probe.src = variant.src;
      if (probe.complete) finish();
      setTimeout(finish, 600);
    });
  }

  function swapBagImages(variant) {
    var images = Array.prototype.slice.call(root.querySelectorAll('[data-sbl-bag-image]')).filter(function (image) {
      return image.getAttribute('src') !== variant.src;
    });
    if (images.length === 0) return;

    if (reducedMotion) {
      images.forEach(function (image) { setBagImage(image, variant); });
      return;
    }

    // A second click mid-slide wins: only the latest swap writes its image.
    var swap = ++bagSwap;
    images.forEach(function (image) {
      image.classList.remove('is-sliding-in');
      image.classList.add('is-sliding-out');
    });

    Promise.all([preload(variant), new Promise(function (resolve) { setTimeout(resolve, BAG_SLIDE_MS); })]).then(function () {
      if (swap !== bagSwap) return;
      images.forEach(function (image) {
        setBagImage(image, variant);
        image.classList.remove('is-sliding-out');
        // Restart the animation even when the class was already there.
        void image.offsetWidth;
        image.classList.add('is-sliding-in');
      });
      setTimeout(function () {
        if (swap !== bagSwap) return;
        images.forEach(function (image) { image.classList.remove('is-sliding-in'); });
      }, BAG_SLIDE_MS + 50);
    });
  }

  function showError(message) {
    if (!errorNode) return;
    errorNode.textContent = message;
    errorNode.hidden = false;
  }

  function hideError() {
    if (!errorNode) return;
    errorNode.hidden = true;
    errorNode.textContent = '';
  }

  function setBusy(busy) {
    state.busy = busy;
    addButtons.forEach(function (button) {
      var label = button.querySelector('[data-sbl-add-label]');
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
      button.disabled = busy;
      if (label) label.textContent = busy ? strings.adding : fill(strings.button, { name: currentTier().name });
    });
  }

  /* ---- tracking ------------------------------------------------------------------ */

  function analyticsItem(tier, variant) {
    var bags = tier ? tier.bags : 1;
    var unit = tier ? tier.price / bags : variant.price;
    return {
      item_id: variant.sku || String(variant.id),
      item_name: data.productTitle,
      item_variant: variant.label,
      item_brand: data.vendor,
      item_category: data.productType,
      item_list_name: tier ? tier.name + ' bundle' : undefined,
      price: Math.round(unit) / 100,
      quantity: bags
    };
  }

  function pushDataLayer(event, value, item) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: event,
      ecommerce: { currency: data.currency, value: value, items: [item] }
    });
  }

  function klaviyoTrack(event, properties) {
    // The Klaviyo app embed defines window.klaviyo as a queue that accepts
    // calls before its script has loaded.
    var klaviyo = window.klaviyo || (window.klaviyo = []);
    if (typeof klaviyo.push === 'function') klaviyo.push(['track', event, properties]);
  }

  function trackView() {
    var variant = currentVariant();
    var tier = currentTier();
    try {
      pushDataLayer('view_item', tier.price / 100, analyticsItem(tier, variant));
      klaviyoTrack('Viewed Product', {
        ProductName: data.productTitle,
        ProductID: data.productId,
        SKU: variant.sku,
        VariantID: variant.id,
        Categories: [data.productType],
        ImageURL: variant.src ? (variant.src.indexOf('//') === 0 ? 'https:' + variant.src : variant.src) : undefined,
        URL: window.location.origin + window.location.pathname,
        Brand: data.vendor,
        Price: variant.price / 100,
        CompareAtPrice: variant.price / 100
      });
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'ViewContent', {
          content_ids: [String(variant.id)],
          content_type: 'product',
          content_name: data.productTitle,
          value: tier.price / 100,
          currency: data.currency
        });
      }
    } catch (error) {
      /* Tracking must never break the page. */
    }
  }

  function trackAdd(tier, variant) {
    try {
      pushDataLayer('add_to_cart', tier.price / 100, analyticsItem(tier, variant));
    } catch (error) {
      /* Tracking must never break the page. */
    }
  }

  /* ---- add to cart ------------------------------------------------------------------ */

  function errorFrom(response) {
    return response.json().then(function (body) {
      return (body && (body.description || body.message)) || strings.error;
    }, function () {
      return strings.error;
    });
  }

  function goToCheckout() {
    if (window.CartGifts && typeof window.CartGifts.goWhenSettled === 'function') {
      window.CartGifts.goWhenSettled('/checkout');
      return;
    }
    // No gift reconciler on the page (no gift switched on): go at once.
    setTimeout(function () {
      window.location.href = '/checkout';
    }, 0);
  }

  function addBundle() {
    if (state.busy) return;

    var tier = currentTier();
    var variant = currentVariant();
    if (!variant.available) {
      showError(strings.soldOut);
      return;
    }

    hideError();
    setBusy(true);

    var previous = [];

    getCart()
      .then(function (cart) {
        previous = (cart.items || []).filter(function (line) {
          return line.properties && line.properties._bundle;
        });

        var same = previous.length === 1 &&
          previous[0].variant_id === variant.id &&
          previous[0].quantity === tier.bags &&
          !previous[0].selling_plan_allocation;
        if (same) return null;

        var removal = Promise.resolve();
        if (previous.length > 0) {
          var updates = {};
          previous.forEach(function (line) {
            updates[line.key] = 0;
          });
          removal = post('/cart/update.js', { updates: updates }).then(function (response) {
            if (!response.ok) return errorFrom(response).then(function (message) { throw new Error(message); });
          });
        }

        return removal.then(function () {
          return post('/cart/add.js', {
            items: [{ id: variant.id, quantity: tier.bags, properties: { _bundle: tier.bags + '-pack' } }]
          });
        }).then(function (response) {
          if (response.ok) return null;
          return errorFrom(response).then(function (message) {
            // Put the bundle the visitor had back, so a failed switch costs nothing.
            if (previous.length === 0) throw new Error(message);
            return post('/cart/add.js', {
              items: previous.map(function (line) {
                return { id: line.variant_id, quantity: line.quantity, properties: line.properties };
              })
            }).catch(function () {}).then(function () {
              throw new Error(message);
            });
          });
        });
      })
      .then(function () {
        trackAdd(tier, variant);
        goToCheckout();
        // If something keeps the page here (a blocked navigation), let the
        // visitor try again.
        setTimeout(function () {
          setBusy(false);
        }, SETTLE_FALLBACK + 4000);
      })
      .catch(function (error) {
        setBusy(false);
        showError(error && error.message ? error.message : strings.error);
      });
  }

  /* ---- sticky bar (phones) -------------------------------------------------------------- */

  var summaryNode = root.querySelector('[data-sbl-summary]');
  var footer = document.querySelector('[data-sbl-footer]');
  var stickyButton = sticky ? sticky.querySelector('[data-sbl-add]') : null;
  var stickyQueued = false;

  function inView(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function updateSticky() {
    stickyQueued = false;
    if (!sticky) return;

    var reached = root.getBoundingClientRect().top < window.innerHeight * 0.6;
    var show = reached && !inView(summaryNode) && !inView(footer);

    sticky.classList.toggle('is-visible', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (stickyButton) stickyButton.setAttribute('tabindex', show ? '0' : '-1');
  }

  function queueSticky() {
    if (stickyQueued) return;
    stickyQueued = true;
    window.requestAnimationFrame(updateSticky);
  }

  /* ---- wiring ---------------------------------------------------------------------- */

  tiers.forEach(function (tier) {
    tier.card.addEventListener('click', function () {
      state.bags = tier.bags;
      render();
    });
  });

  scentButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      state.variantId = parseInt(button.getAttribute('data-sbl-scent'), 10);
      render();
    });
  });

  addButtons.forEach(function (button) {
    button.addEventListener('click', addBundle);
  });

  window.addEventListener('scroll', queueSticky, { passive: true });
  window.addEventListener('resize', queueSticky);

  // Back from checkout (bfcache): the button must not stay on "Adding...".
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) setBusy(false);
  });

  render();
  updateSticky();
  trackView();
})();
